import React from 'react';
import classnames from 'classnames';

import styles from './styles.module.scss';

class DesktopHoverTooltip extends React.Component {
  state = {
    showTooltip: false
  };

  getTooltipName = () => {
    return `${this.props.name}-hover-tooltip-`;
  };

  getElement = () => {
    return document.getElementById(this.getTooltipName());
  };

  componentDidMount() {
    document.addEventListener('mouseover', this.handleHover);
  }

  componentWillUnmount() {
    document.removeEventListener('mouseover', this.handleHover);
  }

  handleHover = event => {
    this.setState({ showTooltip: this.node.contains(event.target) });
  };

  render() {
    const { children, className } = this.props;

    return (
      <div
        ref={node => (this.node = node)}
        className={classnames(styles.desktopDropdown, className, {
          [styles.active]: this.props.active
        })}>
        {children}
        <div
          className={classnames(styles.desktopTooltip, {
            [styles.displayed]: this.state.showTooltip
          })}>
          {this.props.tooltip}
        </div>
        <i className={classnames('material-icons', styles.arrowDown)}>
          keyboard_arrow_down
        </i>
      </div>
    );
  }
}

class HoverTooltip extends React.Component {
  state = {
    showTooltip: false
  };

  componentDidMount() {
    document.addEventListener('mouseover', this.handleHover, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mouseover', this.handleHover, false);
  }

  handleHover = e => {
    // If the hovered element is a child of `node` then we show the tooltip.
    this.setState({ showTooltip: this.node.contains(e.target) });
  };

  render() {
    const { className } = this.props;

    return (
      <div ref={node => (this.node = node)} className={className}>
        <div
          onClick={this.props.onClick}
          className={classnames(styles.trigger, {
            [styles.selected]: this.state.showTooltip,
            [styles.active]: this.props.active
          })}>
          {this.props.children}
        </div>
        <div
          className={classnames(styles.tooltip, {
            [styles.showTooltip]: this.state.showTooltip
          })}>
          {this.props.tooltip}
        </div>
      </div>
    );
  }
}

export { HoverTooltip, DesktopHoverTooltip };
